import { Crown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { fetchTopRunners } from "../utils/rewards";

const LEADER_KEY = "dolo-crown-leader";

/* Crown watch ticker — shows the current Runner of the Week, and calls it out
   when the crown changed hands since this visitor's last radio visit. */
export function CrownTicker() {
  const [leader, setLeader] = useState(null);
  const [changed, setChanged] = useState(false);
  const hasChecked = useRef(false);

  useEffect(() => {
    // run once — a StrictMode double-invoke would read back the leader we just stored
    if (hasChecked.current) return;
    hasChecked.current = true;
    fetchTopRunners()
      .then((rows) => {
        const top = rows[0];
        if (!top) return;
        const seen = localStorage.getItem(LEADER_KEY);
        setChanged(Boolean(seen) && seen !== top.tag);
        localStorage.setItem(LEADER_KEY, top.tag);
        setLeader(top);
      })
      .catch(() => {});
  }, []);

  const name = leader ? leader.name || leader.tag : null;
  const line = !leader
    ? "NO RUNNER CROWNED YET — STACK POINTS AND TAKE THE WEEK"
    : changed
      ? `THE CROWN CHANGED HANDS — ${name} TAKES THE WEEK WITH ${leader.points} PTS`
      : `RUNNER OF THE WEEK: ${name} — ${leader.points} PTS — DETHRONE THEM`;

  return (
    <div className="editorial-marquee crown-ticker" data-testid="crown-ticker">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <span key={half} className="crown-ticker-line" {...(half === 0 ? { "data-testid": "crown-ticker-line" } : {})}>
            {Array.from({ length: 4 }, (_, i) => (
              <em key={i} className={changed ? "is-crown-change" : ""}>
                <Crown size={13} /> CROWN WATCH — {line} —&nbsp;
              </em>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
